import React from 'react';
import { useParams } from 'react-router-dom';

import Styled from './Header.styles';

import { LanguageSelector } from '../LanguageSelector/LanguageSelector';

import SleepioLogo from '@/assets/SleepioLogoIcon.svg';
import SparkDirectLogo from '@/assets/SparkDirectLogo.svg';
import { isSpark as isSparkHelper } from '@/utils/productHelpers';

export const SleepioHeader: React.FC = () => {
  const { product } = useParams<{ product?: string }>();
  const isSpark = isSparkHelper(product);

  if (isSpark) {
    return (
      <Styled.HeaderContainer>
        <Styled.Header>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              position: 'relative',
            }}
          >
            <Styled.SparkLogo
              src={SparkDirectLogo}
              alt="Spark Direct"
              style={{ marginRight: 56 }}
            />
            <LanguageSelector iconOnly />
          </div>
        </Styled.Header>
      </Styled.HeaderContainer>
    );
  }

  return (
    <Styled.HeaderContainer>
      <Styled.SleepioHeader>
        <Styled.SleepioLogo src={SleepioLogo} />
      </Styled.SleepioHeader>
      <LanguageSelector />
    </Styled.HeaderContainer>
  );
};
